import { alertFailure } from "$utils/alerts"
import { resetTokens } from "$utils/auther"
import Routes from "$utils/request/routes"
import translateErrorResponse from "$utils/translateErrorResponse"

const isCommonInfoRequest = request => (
  Object.values(Routes.COMMON).includes(request?.url)
)

const invalidToken = code => code === "invalid_token"

export const processError = ({ code, params } = {}, request) => {
  if (isCommonInfoRequest(request)) return

  alertFailure(translateErrorResponse(code, params))

  if (invalidToken(code)) {
    resetTokens()
    throw new Error("AuthError")
  }
}
